import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Chip
} from '@mui/material';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import CustomModal from '../components/modal/CustomModal';


// hooks

import { useAxios } from '../context/AxiosHookContext';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// form
import { FormCreateUser } from "../components/forms/usersForms/createUsers"
import { useNotification } from '../context/NotificationContext';
import FormCreateTicketCategory from "../components/forms/ticketForms/ticketCategory"

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Categoría', alignRight: false },
  { id: 'name', label: 'Tipo', alignRight: false },
  { id: 'active', label: 'Estado', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function TicketsCategoryPage() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');
  const { showSnackbar } = useNotification();
  const [selectedTypes, setSelectedTypes] = useState(["support_type", "support_subtype", "support_subtype_1"])
  const [activeFilter, setActiveFilter] = useState('all')

  const [openModalTicketsCategory, setOpenModalTicketCategory] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [ticketsCategory, setTicketCategoryList] = useState([])
  const [sync, setSync] = useState(false)
  const [valuesToEdit, setValuesToEdit] = useState({})

  const CATEGORY_API = `/tickets/category?page=${page}&limit=10&displayName=${filterName}&types=${JSON.stringify(selectedTypes)}${activeFilter !== 'all' ? `&active=${activeFilter}` : ''}`
  const axios = useAxios();

  const handleOpenMenu = (event, values) => { 
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };


  const getOrgs = useCallback(async () => {
    try {
      setTicketCategoryList([])
      setLoading(true);
      const { data } = await axios.get(CATEGORY_API);
      setTicketCategoryList(data.data.list);
      setTotalPages(data.data.total_pages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, CATEGORY_API, setTicketCategoryList, setLoading]);



  useEffect(() => {
    getOrgs();
  }, [getOrgs, filterName])


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };


  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Categorías de tickets | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>


        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Categoría de tickets
          </Typography>
          <Button variant="contained" startIcon={sync ? <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} /> : <Iconify icon="eva:plus-fill" />} onClick={() => setOpenModalTicketCategory(true)}>
            Agregar
          </Button>
        </Stack>

        <Card>

          <Grid container alignItems={"center"}>
            <Grid item>
              <FormControl sx={{ width: 250, m: 2 }}>
                <InputLabel
                  id="role-label"
                  sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
                >
                  Descripción
                </InputLabel>
                <Select
                  labelId="role-label"
                  id="role"
                  multiple
                  value={selectedTypes}
                  onChange={(e) => { setSelectedTypes(e.target.value) }}
                  size="small"
                  label="displayName tickets"
                >
                  <MenuItem value="support_type">Categoría</MenuItem>
                  <MenuItem value="support_subtype">Subtipo de categoría</MenuItem>
                  <MenuItem value="support_subtype_1">Subtipo técnico</MenuItem>
                </Select>
              </FormControl>

            </Grid>

            <Grid item>
              <FormControl sx={{ width: 200, m: 2 }}>
                <InputLabel id="active-label" sx={{ marginTop: '-0.4rem' }}>Estado</InputLabel>
                <Select
                  labelId="active-label"
                  value={activeFilter}
                  onChange={(e) => { setActiveFilter(e.target.value); setPage(1); }}
                  size="small"
                  label="Estado"
                >
                  <MenuItem value="all">Todos</MenuItem>
                  <MenuItem value="true">Habilitados</MenuItem>
                  <MenuItem value="false">Deshabilitados</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />
            </Grid>
          </Grid>

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {ticketsCategory?.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox">

                    <TableCell component="th" scope="row" padding="normal">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography variant="subtitle2" noWrap>
                          {row.displayName}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="left">
                      {row?.type === "support_type" ? "Categoría" : row?.type === "support_subtype" ? "Subtipo de categoría" : "Subtipo técnico"}
                    </TableCell>

                    <TableCell align="left">
                      <Chip
                        label={(row.active ?? true) ? "Habilitado" : "Deshabilitado"}
                        color={(row.active ?? true) ? "success" : "error"}
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (ticketsCategory.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados para
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />


        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalTicketCategory(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>
      </Popover>

      <CustomModal
        open={openModalTicketsCategory}
        modalStyle={{ maxWidth: 800, minWidth: 440 }}
        title={"Formulario de categoría de tickets"}
      >
        <FormCreateTicketCategory
          onClose={() => setOpenModalTicketCategory(false)}
          getValues={() => {
            getOrgs();
            setOpenModalTicketCategory(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
